module.exports = __webpack_public_path__ + "static/img/news_banner.abf444a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_banner.png
// module id = RVWZ
// module chunks = 0